module.exports = __webpack_public_path__ + "img/Sage.1b11e066.svg";